<template>
    <div id="apiary-card-minimalist-component" class="h-100">
        <!-- MOBILE -->
        <template v-if="is_mobile">
            <!--            A faire-->
        </template>

        <!-- DESKTOP -->
        <template v-else>
            <div class="position-relative h-100">
                <v-card
                    :class="`${is_selected ? 'minimalist-asset-card-selected' : 'minimalist-asset-card'} h-100 desktop-asset-card`"
                    data-cy="minimalist-asset-card"
                    elevation="0"
                >
                    <v-card-text class="h-100 font-color-normal">
                        <div class="no-drag">
                            <div class="d-flex justify-space-between">
                                <p class="mb-0 font-weight-bold font-18 text-overflow-ellipsis font-color-default">
                                    {{ apiary.name }}
                                </p>

                                <MenuActionsComponent
                                    :actions="[
                                        {
                                            title: $t('global.modify'),
                                            icon: 'mdi-pencil-outline',
                                            emit: 'openDialogAddEditApiary',
                                            has_access: userHasAccess(asset_module.designation, role_edit),
                                        },
                                        {
                                            title: $t('global.delete'),
                                            icon: 'mdi-close-circle-outline',
                                            emit: 'openDialogDeleteApiary',
                                            color: 'error',
                                            has_access: userHasAccess(asset_module.designation, role_all_access),
                                        },
                                    ]"
                                    v-on:openDialogAddEditApiary="$refs.addEditApiaryDialog.openDialogAddEditApiary(apiary)"
                                    v-on:openDialogDeleteApiary="$refs.deleteApiaryFormDialog.openDialogDeleteApiary(apiary)"
                                />
                            </div>
                        </div>

                        <div class="d-flex align-center w-fit gap-5 h-100">
                            <img :src="'/images/global/apiaries.png'" alt="asset" height="60" />

                            <div class="pl-4 font-14">
                                <v-row>
                                    <span class="font-color-light">
                                        {{ $t('global_apiary.number_hives') }}
                                    </span>
                                    <span class="pl-2 font-color-medium font-weight-bold">
                                        {{ apiary.hives.length }}
                                    </span>
                                </v-row>

                                <v-row>
                                    <span class="font-color-light">
                                        {{ $t('global_apiary.weight_average') }}
                                    </span>
                                    <span class="pl-2 font-color-medium font-weight-bold">
                                        {{ `${apiary.weight_average} Kg` }}
                                    </span>
                                </v-row>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </template>

        <AddEditApiaryDialogComponent ref="addEditApiaryDialog" v-on:apiaryUpdated="refreshApiaries" />
        <DeleteApiaryFormDialogComponent ref="deleteApiaryFormDialog" v-on:apiaryDeleted="refreshApiaries" />
    </div>
</template>

<script>
import MenuActionsComponent from '@/components/global/containment/MenuActionsComponent.vue'
import AddEditApiaryDialogComponent from '@/components/equipment/apiary/form/AddEditApiaryDialogComponent.vue'
import DeleteApiaryFormDialogComponent from '@/components/equipment/apiary/form/DeleteApiaryFormDialogComponent.vue'

export default {
    name: 'ApiaryCardMinimalistComponent',
    components: { DeleteApiaryFormDialogComponent, AddEditApiaryDialogComponent, MenuActionsComponent },
    props: {
        apiary: {
            type: Object,
            required: true,
        },
        is_selected: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            asset_module: null,
        }
    },
    created() {
        this.asset_module = this.$store.getters['asset_module/asset_modules'].find((module) => module.designation === 'GNC_HIVE')
    },
    methods: {
        refreshApiaries() {
            this.$emit('refreshApiaries')
        },
    },
}
</script>
